export default (applyHeaderAndIndent, headerText, fields) => applyHeaderAndIndent ? (
  [
    { label: headerText, isLabelOnly: true },
    ...fields.map(field => ({ ...field, isIndented: true }))
  ]
) : (
    fields
  );